import { INavLink } from '../../lib/Sidebar/Sidebar';

export const sidebarNavLinks: INavLink[] = [
  {
    label: 'Goals',
    url: '/signup/business-goals',
    id: 'businessGoals',
  },
  {
    label: 'Service',
    url: '/signup/travel',
    id: 'travel',
  },
  {
    label: 'Mobile Location',
    url: '/signup/location',
    id: 'location',
  },
  {
    label: 'Travel zones',
    url: '/signup/set-ib-travel-zones',
    id: 'ibTravelZones',
  },
  {
    label: 'Studio Location',
    url: '/signup/set-home-studio',
    id: 'studioLocation',
  },
  {
    label: 'Pricing',
    url: '/signup/pricing',
    id: 'pricing',
  },
  {
    label: 'Calendar setup',
    url: '/signup/set-ib-availability-windows',
    id: 'ibAvailabilityWindows',
  },
  {
    label: 'Instagram',
    url: '/signup/set-instagram',
    id: 'instagram',
  },
  {
    label: 'Kit',
    url: '/signup/set-kit',
    id: 'kit',
  },
  {
    label: 'Bio',
    url: '/signup/set-bio',
    id: 'bio',
  },
  {
    label: 'Profile photo',
    url: '/signup/profile-photo',
    id: 'photo',
  },
  {
    label: 'Submit',
    url: '/signup/submit',
    id: '',
  },
];
